import { useEffect, useState } from "react";
import GlobalModalComponent from "../../../../shared/globalModal/GlobalModalComponent";
import CloseLeft from "../../../../../assets/images/pages/login/CaretLeft.svg";
import CloseIcon from "../../../../../assets/images/pages/login/CloseButton.svg";
import logo from "../../../../../assets/images/site-logo/Logo.png";
import { OtpInput } from "reactjs-otp-input";
import styles from "./OtpModal.module.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  setErrorMessage,
  setIsChangePassword,
  setIsForgetPassword,
  setIsLogin,
  setIsMessage,
  setIsMessageStatus,
  setIsOtp,
  setIsRegister,
  setOtpType,
} from "../../../../../redux/Slices/userSlice";
import { Link } from "react-router-dom";
import MainButton from "../../../../shared/button/MainButton";
import arrowCounter from "../../../../../assets/images/pages/login/ArrowCounterClockwise.svg";
import { RootState } from "../../../../../redux/store";
import { resendOtp, verifyUser } from "../../../../../services/auth.service";

const OtpModal = () => {
  const [isModal, setIsModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [timeLeft, setTimeLeft] = useState(180);
  const [resend, setResend] = useState(false);
  const handleOtpTypeSelection = (type: "sms" | "mail") => {
    dispach(setOtpType(type));
  };
  const otpType = useSelector((state: RootState) => state.user.otpType);

  const otpSession = useSelector((state: RootState) => state.user.otpSession);
  const operationType = useSelector(
    (state: RootState) => state.user.operationType
  );
  const { data } = useSelector((state: RootState) => state.translationData);

  const dispach = useDispatch();

  const LoginClose = () => {
    dispach(setIsRegister(true));
    dispach(setIsOtp(false));
    dispach(setIsLogin(false));
  };

  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  const handleResend = async () => {
    if (timeLeft > 0) return;
    setResend(true);
    setOtp("");
    setTimeLeft(120);

    try {
      const payload = {
        otpSession: otpSession,
      };
      await resendOtp(payload);
    } catch (error: any) {
      dispach(setErrorMessage(error?.response?.data?.content));
    } finally {
      setTimeout(() => {
        setResend(false);
      }, 4000);
    }
  };
  const handleOtpChange = (otpValue: string) => {
    setOtp(otpValue);
    dispach(setErrorMessage(""));
  };

  const handleSubmitOtp = async () => {
    dispach(setErrorMessage(""));
    dispach(setIsRegister(false));
    dispach(setIsOtp(false));
    dispach(setIsLogin(false));
    dispach(setIsForgetPassword(false));

    try {
      await verifyUser({ otpSession, otp });
      dispach(setIsChangePassword(true));
      dispach(setIsMessageStatus(true));

      if (operationType === "register") {
        dispach(setIsLogin(true));
        dispach(setIsChangePassword(false));
      } else if (operationType === "forgetPassword") {
        dispach(setIsChangePassword(true));
        dispach(setIsLogin(false));
        dispach(setIsForgetPassword(false));
        dispach(setIsMessage(false));
      }
    } catch (error: any) {
      dispach(setErrorMessage(error?.response?.data?.content));
      dispach(setIsMessageStatus(false));
      dispach(setIsChangePassword(false));
    } finally {
      dispach(setIsMessage(true));
    }
  };

  return (
    <GlobalModalComponent isOpen={true} onClose={() => setIsModal(!isModal)}>
      <div className={styles.otpModal}>
        <div className={styles.headerLogin}>
          <div className={styles.headerLeft} onClick={LoginClose}>
            <img className={styles.backLoginIcon} src={CloseLeft} alt="left" />
            <p className={styles.backLoginText}>Geri</p>
          </div>
          <Link to={"/"} onClick={LoginClose} className={styles.closeButton}>
            <img
              className={styles.closeIcon}
              src={CloseIcon}
              alt="EyeIcon"
              onClick={LoginClose}
            />
          </Link>
        </div>
        <div className={styles.modalContainer}>
          <div className={styles.logo}>
            <img src={logo} alt="colibri" />
          </div>
          <h3 className={styles.loginTitle}>
            {otpType === "sms"
              ? "Otp Kodunuz Mobil Nomrenize ugurla gonderildi"
              : data?.auth_common_otp_email_sent}
          </h3>

          <OtpInput
            value={otp}
            onChange={handleOtpChange}
            numInputs={6}
            className={styles.OtpInput}
            separator={<span></span>}
            inputStyle={{
              width: "60px",
              height: "60px",
              margin: "0 8px",
              fontSize: "22px",
              textAlign: "center",
              border: "2px solid #EBEBEB",
              borderRadius: "8px",
              backgroundColor: "#EBEBEB",
            }}
          />
          <div className={styles.otp_timer}>
            <p>
              <span
                style={{ color: timeLeft <= 10 ? "red" : "#f05922" }}
                className={styles.timer}
              >
                <strong>{formatTime(timeLeft)}</strong>
              </span>
            </p>
            <div
              className={`${styles.resend_section} ${
                timeLeft > 0 ? styles.disabled_resend : ""
              }`}
              onClick={timeLeft > 0 ? undefined : handleResend}
            >
              <div
                className={`${styles.resendIcon} ${
                  resend ? styles.rotate : ""
                }`}
              >
                <img src={arrowCounter} alt="arr" />
              </div>
              <div>{data?.auth_common_resend_code}</div>
            </div>
          </div>
        </div>
        <div className={styles.otp_btn}>
          <MainButton
            onClick={handleSubmitOtp}
            text={data?.auth_azerpost_confirm}
            disabled={otp.length < 6}
            className={`${styles.submitBtn} ${
              otp.length < 6 ? styles.disabledBtn : ""
            }`}
          />
        </div>
      </div>
    </GlobalModalComponent>
  );
};

export default OtpModal;
